"use client"

import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { useState, useEffect } from "react";

const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "BrightWave Marketing",
    avatar: "/image/avatars/avatar1.png",
    text: "The team at WheelTox made buying wheels online so easy. The website is user-friendly, and I found exactly what I needed.",
    subtext: "The customer support team was responsive and helpful. The wheels fit perfectly, and the quality exceeded my expectations.",
  },
  {
    id: 2,
    name: "David Martinez",
    company: "SkyHigh Media",
    avatar: "/image/avatars/avatar2.png",
    text: "Choosing WheelTox was the best decision we made for our vehicle needs. The wheel selection is impressive and the process was seamless.",
    subtext: "The process was smooth from start to finish. Their support team was helpful, and the wheels arrived on time and in perfect condition.",
    highlight: "Highly recommend",
  },
  {
    id: 3,
    name: "Michael Chen",
    company: "AutoPro Services",
    avatar: "/image/avatars/avatar3.png",
    text: "I purchased refurbished wheels for my Audi at an amazing price. It so easy to browse and choose the right fit.",
    subtext: "The wheels look great on my car, and will definitely shop here again.",
  },
  {
    id: 4,
    name: "Michael Chen",
    company: "AutoPro Services",
    avatar: "/image/avatars/avatar3.png",
    text: "I purchased refurbished wheels for my Audi at an amazing price. It so easy to browse and choose the right fit.",
    subtext: "The wheels look great on my car, and will definitely shop here again.",
  },
  {
    id: 5,
    name: "Michael Chen",
    company: "AutoPro Services",
    avatar: "/image/avatars/avatar3.png",
    text: "I purchased refurbished wheels for my Audi at an amazing price. It so easy to browse and choose the right fit.",
    subtext: "The wheels look great on my car, and will definitely shop here again.",
  },
  {
    id: 6,
    name: "Michael Chen",
    company: "AutoPro Services",
    avatar: "/image/avatars/avatar3.png",
    text: "I purchased refurbished wheels for my Audi at an amazing price. It so easy to browse and choose the right fit.",
    subtext: "The wheels look great on my car, and will definitely shop here again.",
  },
];

export default function TestimonialsSection() {
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (!api) return;
  }, [api]);

  return (
    <section className="px-4 md:px-8 lg:px-20 pt-30 mb-20">
      {/* Header - Centered with arrows at top right */}
      <div className="relative mb-12">
        {/* Centered text */}
        <div className="flex items-center justify-center gap-2">
          <Star className="w-5 h-5 fill-warning text-warning" />
          <span className="font-plus-jakarta font-semibold text-neutral-500">Rated 5/5</span>
          <span className="font-plus-jakarta text-neutral-300">By Happy Customers</span>
        </div>
        {/* Arrows at top right */}
        <div className="absolute right-4 md:right-8 lg:right-20 top-0 flex gap-2">
          <Button
            onClick={() => api?.scrollPrev()}
            className="w-10 h-10 rounded-full bg-primary hover:bg-primary/90 p-0"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <Button
            onClick={() => api?.scrollNext()}
            className="w-10 h-10 rounded-full bg-primary hover:bg-primary/90 p-0"
          >
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      {/* Testimonials Carousel with fade on sides */}
      <div className="relative">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <Carousel
          setApi={setApi}
          opts={{
            align: "center",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {testimonials.map((testimonial) => (
              <CarouselItem key={testimonial.id} className="basis-[80%] md:basis-[45%] lg:basis-[33%]">
                <Card className="border-none shadow-none bg-transparent h-full">
                  <CardContent className="p-6">
                    <p className="font-plus-jakarta text-neutral-900 text-base mb-4">
                      {testimonial.text}
                    </p>
                    <p className="font-plus-jakarta text-neutral-300 text-sm mb-6">
                      {testimonial.subtext}{" "}
                      {testimonial.highlight && (
                        <span className="text-primary font-semibold">
                          {testimonial.highlight}
                        </span>
                      )}
                    </p>
                    <div className="flex items-center gap-3">
                      <Avatar className="w-10 h-10">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.name} />
                        <AvatarFallback className="bg-primary/20 text-primary">{testimonial.name.charAt(0)}</AvatarFallback>
                      </Avatar>
                      <div>
                        <p className="font-plus-jakarta font-semibold text-neutral-900 text-sm">
                          {testimonial.name}
                        </p>
                        <p className="font-plus-jakarta text-neutral-300 text-xs">
                          {testimonial.company}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  );
}
